import { ArrowClockwise, DownloadSimple } from "@phosphor-icons/react";
import { openAppStore } from "../lib/native";

// Tela bloqueante de atualização obrigatória (não dá para fechar).
export default function ForcedUpdate({ info }) {
  const message = info?.message || "Uma nova versão do AlugaJá está disponível. Atualize para continuar usando o app.";
  const store = info?.platform === "ios" ? "App Store" : "Google Play";
  return (
    <div
      className="fixed inset-0 z-[9999] bg-[#004E98] text-white flex flex-col items-center justify-center px-8 text-center pt-safe pb-safe"
      data-testid="forced-update-screen"
    >
      <div className="w-20 h-20 rounded-3xl bg-white/15 flex items-center justify-center mb-6">
        <ArrowClockwise size={40} weight="bold" />
      </div>
      <h1 className="font-heading font-black text-2xl mb-2">Atualização necessária</h1>
      <p className="text-white/85 text-base max-w-sm mb-1">{message}</p>
      <p className="text-white/50 text-xs mb-8">
        Versão instalada {info?.installed} · mínima exigida {info?.min}
      </p>
      <button
        onClick={() => openAppStore({ storeUrl: info?.storeUrl, platform: info?.platform })}
        className="bg-[#FF6B35] text-white font-bold rounded-full px-8 py-3 flex items-center gap-2 active:scale-95 transition-transform"
        data-testid="forced-update-btn"
      >
        <DownloadSimple size={20} weight="bold" />
        Atualizar na {store}
      </button>
    </div>
  );
}
